import { memo } from 'react';
import { Badge } from '@aimsos/ui';

import { STUDIO_BADGE_VARIANT } from '../../constants/copy';

/**
 * Studio tag, colored per studio (unknown studios stay neutral).
 *
 * @param {object} props
 * @param {string} props.id Studio id (`governance`, `data`, `agentic`).
 * @param {string} props.name Display name.
 */
function StudioBadge({ id, name }) {
  return (
    <Badge variant={STUDIO_BADGE_VARIANT[id] ?? 'secondary'} size="small">
      {name}
    </Badge>
  );
}

export default memo(StudioBadge);
